var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n        Copyright © "+_vm._s(_vm.copytext)+" - Version "),_c('strong',[_vm._v("3.0.0-dev-"+_vm._s(_vm.build))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }